<template>
  <div>
    <v-toolbar color="transparent" flat>
      <v-spacer></v-spacer>
      <v-btn color="primary" depressed @click="print">
        <v-icon left>print</v-icon>Print
      </v-btn>
    </v-toolbar>

    <div id="printMe" v-if="enquiryData">
      <table width="100%" style="border:0px solid;" cellspacing="0" cellpadding="0">
        <tr bgcolor="#e53935" style="color:black">
          <td style="height:30px;padding-top:5px;padding-bottom:5px; border-bottom:1px solid;" valign="top">
            <p
              style="text-align:center; font-size:16px; margin-top:0px; margin-bottom:0px;"
            >Enquiry & Quotation Details</p>
            <p
              style="text-align:center; margin-top:0px; margin-bottom:0px;"
            >{{moment().format("Do MMMM  YYYY")}}</p>
          </td>
        </tr>

        <tr>
          <td style="height:60px;" valign="top">
            <table width="100%" cellspacing="0" cellpadding="0">
              <tr>
                <td width="50%" style="height:60px; border-right:0px solid;">
                  <img src="../../assets/a2zhoreca.png" width="120">
                  <p
                    style="text-align:left; font-size:15px; margin-top:0px; margin-bottom:0px;"
                  >A<span style="font-size:12px">2</span>Z
                 <span style="color:#e53935">HO</span>tel 
                 <span style="color:#e53935">RE</span>staurant 
                 <span style="color:#e53935">CA</span>tering</p>
                </td>
                <td width="50%" style="height:60px;" valign="top">
                  <p
                    style="text-align:right; font-size:12px; font-weight:bold; margin-top:0px; margin-bottom:0px;"
                  >GSTIN: 19AAEFF2194C1ZL</p>
                  <p
                    style="text-align:right; font-weight:bold; margin-bottom:0px; margin-top:4px;"
                  >Saila Dubi Road, North Nimta</p>
                  <p
                    style="text-align:right; font-weight:bold; margin-top:4px; margin-bottom:0px;"
                  >West Bengal - 700049</p>
                  <p style="text-align:right; font-weight:bold; margin-bottom:0px; margin-top:4px;">
                    <i class="fa fa-phone" aria-hidden="true"></i> +91 7003672536
                  </p>
                  <p
                    style="text-align:right; font-weight:bold;  margin-top:4px; margin-bottom:4px;"
                  >
                    <i class="fa fa-envelope-o" aria-hidden="true"></i> info@a2zhoreca.com |
                    <i class="fa fa-globe" aria-hidden="true"></i> www.a2zhoreca.com
                  </p>
                </td>
              </tr>
            </table>
          </td>
        </tr>

         <tr>
          <td width="100%">
            <table width="100%" cellspacing="0" cellpadding="0">
              <tr>
                <td
                  width="50%"
                  style="border-top:1px solid; height:auto; border-right:1px solid;  padding-left:10px;"
                  valign="top"
                >
                  <table>
                    <tr>
                      <td>Customer Name</td>
                      <td>:&nbsp;&nbsp;{{enquiryData.fullName}}</td>
                    </tr>
                    <tr>
                      <td>Email ID </td>
                      <td>:&nbsp;&nbsp;{{enquiryData.email}}</td>
                    </tr>
                    <tr>
                      <td
                        style="text-align:left; font-size:15px; font-weight:bold; margin-top:0px; margin-bottom:0px;"
                      >Mobile No. </td>
                      <td
                        style="text-align:left; font-size:15px; font-weight:bold; margin-top:0px; margin-bottom:0px;"
                      >
                        : &nbsp;+91&nbsp;&nbsp;{{enquiryData.mobileNumber}}
                      </td>
                    </tr>
                    <tr>
                      <td style="height:10px"></td>
                      <td></td>
                    </tr>
                  </table>
                </td>
                <td
                  width="50%"
                  style="border-top:1px solid; height:auto; padding-left:10px;"
                  valign="top"
                >
                  <table>
                    <tr>
                      <td style="font-weight:bold;">Enquiry ID </td>
                      <td style="font-weight:bold;">:&nbsp;&nbsp;<span style=" font-size:13px">{{enquiryData.code}}</span></td>
                    </tr>
                    <tr>
                      <td>Enquiry Date </td>
                      <td>:&nbsp;&nbsp;{{enquiryData.orderDate}}</td>
                    </tr>
                    
                    <tr>
                      <td></td>
                      <td></td>
                    </tr>
                  </table>
                </td>
              </tr>
            </table>
          </td>
        </tr>
       
        <tr>
          <td width="100%">
              <table cellspacing="0" cellpadding="0" width="100%">
                  <tr bgcolor="#212121">
                      <td width="100%" style="border-top:1px solid;border-right:1px solid;border-left:1px solid;">
                          <h4 style="text-align:center;padding-top:5px;color:white;">Enquiry Details</h4>
                      </td>
                  </tr>
              </table>
          </td>
        </tr>
        <tr>
          <td width="100%">
            <table cellspacing="0" cellpadding="0" width="100%">
              <tr bgcolor="#eeeeee">
                <td
                  style="border-top:1px solid;border-right:1px solid; border-left:1px solid; border-bottom:1px solid; height:30px; text-align:center;"
                  width="6%"
                >SL No.</td>
                <td
                  width="85%"
                  style="border-top:1px solid;border-right:1px solid; border-bottom:1px solid; text-align:center; height:20px;"
                >Description of Products</td>
                <td
                  width="9%"
                  style="border-top:1px solid; border-bottom:1px solid; border-right:1px solid; text-align:center; height:20px;"
                >Quantity</td>
              </tr>
            </table>
          </td>
        </tr>
        <tr>
          <td width="100%">
            <table cellspacing="0" cellpadding="0" width="100%">
              <tr v-for="(order, index) in enquiryData.orderList" :key="order.id">
                <td
                  style="border-bottom:1px solid;border-right:1px solid; border-left:1px solid; height:20px; text-align:center;"
                  width="6%"
                >{{index + 1}}</td>
                <td
                  width="85%"
                  style="border-bottom:1px solid; text-align:center;border-right:1px solid; height:40px;"
                ><!-- <img height="50px" width="30px" style="margin:10px" :src=order.src /> -->
                    {{order.name}}</td>
                <td
                  width="9%"
                  style="border-right:1px solid; border-bottom:1px solid; text-align:center; height:20px;"
                >{{order.quantity}}</td>
              </tr>
            </table>
          </td>
        </tr>
        
        <tr>
          <td width="100%" height="10px">
          </td>
        </tr>

        <tr v-for="(quotation, index) in enquiryData.quotationList" :key="quotation.id">
          <td width="100%">
              <table cellspacing="0" cellpadding="0" width="100%">
                  <tr bgcolor="#212121">
                      <td width="100%" style="border-top:1px solid;border-right:1px solid;border-left:1px solid;">
                          <h5 style="text-align:center;padding-top:5px;color:white;">Quotation :&nbsp;{{index + 1}}</h5>
                      </td>
                  </tr>
              </table>

              <table width="100%" cellspacing="0" cellpadding="0">
              <tr>
                <td
                  width="33%"
                  style="border-top:1px solid; height:auto; border-right:1px solid;  padding-left:10px;"
                  valign="top"
                >
                  <table>
                    <tr>
                      <td>Vendor Name</td>
                      <td>:&nbsp;&nbsp;{{quotation.companyName}}</td>
                    </tr>
                    <tr>
                      <td>Contact Person </td>
                      <td>:&nbsp;&nbsp;{{quotation.contactPerson}}</td>
                    </tr>
                    <tr>
                      <td
                        style="text-align:left; font-size:15px; font-weight:bold; margin-top:0px; margin-bottom:0px;"
                      >Mobile No. </td>
                      <td
                        style="text-align:left; font-size:15px; font-weight:bold; margin-top:0px; margin-bottom:0px;"
                      >
                        : &nbsp;+91&nbsp;&nbsp;{{quotation.mobileNumber}}
                      </td>
                    </tr>
                    <tr>
                      <td style="height:10px"></td>
                      <td></td>
                    </tr>
                  </table>
                </td>
                <td
                  width="34%"
                  style="border-top:1px solid; border-right:1px solid; height:auto; padding-left:10px;"
                  valign="top"
                >
                  <table>
                    <tr>
                      <td>Email ID </td>
                      <td>:&nbsp;&nbsp;{{quotation.email}}</td>
                    </tr>
                    <tr>
                      <td>Office Address </td>
                      <td>:&nbsp;&nbsp;{{quotation.officeAddress1}}</td>
                    </tr>
                    <tr>
                      <td>Factory Address </td>
                      <td>:&nbsp;&nbsp;{{quotation.factoryAddress1}}</td>
                    </tr>
                    
                    <tr>
                      <td></td>
                      <td></td>
                    </tr>
                  </table>
                </td>
                <td
                  width="33%"
                  style="border-top:1px solid; height:auto; padding-left:10px;"
                  valign="top"
                >
                  <table>
                    <tr>
                      <td style="font-weight:bold;">Quotation ID </td>
                      <td style="font-weight:bold;">:&nbsp;&nbsp;<span style=" font-size:13px">{{quotation.code}}</span></td>
                    </tr>
                    <tr>
                      <td>Quotation Date </td>
                      <td>:&nbsp;&nbsp;{{quotation.quotationDate}}</td>
                    </tr>
                    
                    <tr>
                      <td></td>
                      <td></td>
                    </tr>
                  </table>
                </td>
              </tr>
            </table>

            <table cellspacing="0" cellpadding="0" width="100%">
              <tr bgcolor="#eeeeee">
                <td
                  style="border-top:1px solid;border-right:1px solid; border-left:1px solid; border-bottom:1px solid; height:30px; text-align:center;"
                  width="6%"
                >SL No.</td>
                <td
                  width="61%"
                  style="border-top:1px solid;border-right:1px solid; border-bottom:1px solid; text-align:center; height:20px;"
                >Description of Products</td>
                <td
                  width="9%"
                  style="border-top:1px solid; border-bottom:1px solid; border-right:1px solid; text-align:center; height:20px;"
                >Quantity</td>
                <td
                  width="12%"
                  style="border-top:1px solid; border-bottom:1px solid; border-right:1px solid; text-align:center; height:20px;"
                >Rate</td>
                <td
                  width="12%"
                  style="border-top:1px solid; border-bottom:1px solid; border-right:1px solid; text-align:center; height:20px;"
                >Total</td>
              </tr>
            </table>

            <table cellspacing="0" cellpadding="0" width="100%">
              <tr v-for="(item, index) in quotation.list" :key="item.id">
                <td
                  style="border-right:1px solid; border-left:1px solid; border-bottom:1px solid; height:30px; text-align:center;"
                  width="6%"
                >{{index + 1}}</td>
                <td
                  width="61%"
                  style="border-right:1px solid; border-bottom:1px solid; text-align:center; height:20px;"
                >{{item.name}}</td>
                <td
                  width="9%"
                  style="border-bottom:1px solid; border-right:1px solid; text-align:center; height:20px;"
                >{{item.quantity}}</td>
                <td
                  width="12%"
                  style="border-bottom:1px solid; border-right:1px solid; text-align:center; height:20px;"
                >{{(item.rate).toFixed(2)}}</td>
                <td
                  width="12%"
                  style="border-bottom:1px solid; border-right:1px solid; text-align:center; height:20px;"
                >{{(item.rate * item.quantity).toFixed(2)}}</td>
              </tr>
            </table>

            <table cellspacing="0" cellpadding="0" width="100%">
                <tr bgcolor="#eeeeee">
                    <td width="100%" style="border-left:1px solid;border-bottom:1px solid;border-right:1px solid;font-weight:bold;text-align:right;padding:5px;" height="40">
                        Total Amount : {{(quotation.totalAmount).toFixed(2)}}
                    </td>
                </tr>
            </table>
          </td>
        </tr>

        <!--

        

        <tr>
          <td width="100%">
            <table cellspacing="0" cellpadding="0" width="100%">
              <tr v-for="(invoice, index) in invoiceData.salesOrderDetails" :key="invoice.id">
                <td
                  style="border-top:1px solid; border-right:1px solid; height:3px; text-align:center;"
                  width="3%"
                >{{index + 1}}</td>
                <td
                  width="14%"
                  style="border-top:1px solid; border-right:1px solid; text-align:center; height:10px;"
                >{{invoice.itemName}}</td>
                <td
                  width="6%"
                  style="border-top:1px solid; border-right:1px solid; text-align:center; height:10px;"
                >{{invoice.hsnCode}}</td>
                <td
                  width="6%"
                  style="border-top:1px solid; border-right:1px solid; text-align:center; height:10px;"
                >{{invoice.batchNumber}}</td>
                <td
                  width="6%"
                  style="border-top:1px solid; border-right:1px solid; text-align:center; height:10px;"
                >{{invoice.mfg_Date}}</td>
                <td
                  width="6%"
                  style="border-top:1px solid; border-right:1px solid; text-align:center; height:10px;"
                >{{invoice.expiry_Date}}</td>
                <td
                  width="6%"
                  style="border-top:1px solid; border-right:1px solid; text-align:center; height:10px;"
                >{{invoice.quantity}} ({{invoice.unit}})</td>
                <td
                  width="6%"
                  style="border-top:1px solid; border-right:1px solid; text-align:center; height:10px;"
                >{{invoice.dp}}</td>
                <td
                  width="8%"
                  style="border-top:1px solid; border-right:1px solid; text-align:center; height:10px;"
                >{{invoice.taxableAmount}}</td>
                <td
                  width="10%"
                  style="border-top:1px solid; border-right:1px solid; text-align:center; height:10px;"
                >
                  <table width="100%" cellspacing="0" cellpadding="0">
                    <tr>
                      <td
                        width="30%"
                        style="border-right:1px solid; height:20px;"
                      >{{invoice.cgsT_Rate}}</td>
                      <td width="70%">{{invoice.cgsT_Amount}}</td>
                    </tr>
                  </table>
                </td>

                <td
                  width="10%"
                  style="border-top:1px solid; border-right:1px solid; text-align:center; height:20px;"
                >
                  <table width="100%" cellspacing="0" cellpadding="0">
                    <tr>
                      <td
                        width="30%"
                        style="border-right:1px solid; height:20px;"
                      >{{invoice.sgsT_Rate}}</td>
                      <td width="70%">{{invoice.sgsT_Amount}}</td>
                    </tr>
                  </table>
                </td>

                <td width="10%" style="border-top:1px solid;  text-align:center; height:10px;">
                  <table width="100%" cellspacing="0" cellpadding="0">
                    <tr>
                      <td
                        width="30%"
                        style="border-right:1px solid; height:10px;"
                      >{{invoice.igsT_Rate}}</td>
                      <td width="70%">{{invoice.igsT_Amount}}</td>
                    </tr>
                  </table>
                </td>
                <td
                  width="8%"
                  style="border-top:1px solid; border-left:1px solid;  text-align:center; height:10px;"
                >{{ (invoice.cgsT_Amount + invoice.sgsT_Amount +invoice.igsT_Amount) }}</td>
              </tr>
            </table>
          </td>
        </tr>

        <tr bgcolor="#999999">
          <td width="100%">
            <table cellspacing="0" cellpadding="0" width="100%">
              <tr>
                <td
                  width="41%"
                  style="border-top:1px solid; border-right:1px solid; text-align:center; height:10px;"
                >Colums Total</td>
                <td
                  width="6%"
                  style="border-top:1px solid; border-right:1px solid; text-align:center; height:10px;"
                ></td>
                <td
                  width="6%"
                  style="border-top:1px solid; border-right:1px solid; text-align:center; height:10px;"
                ></td>
                <td
                  width="8%"
                  style="border-top:1px solid; border-right:1px solid; text-align:center; height:10px;"
                ></td>
                <td
                  width="10%"
                  style="border-top:1px solid; border-right:1px solid; text-align:center; height:10px;"
                >
                  <table width="100%" cellspacing="0" cellpadding="0">
                    <tr>
                      <td width="30%" style="border-right:1px solid; height:20px;"></td>
                      <td width="70%"></td>
                    </tr>
                  </table>
                </td>

                <td
                  width="10%"
                  style="border-top:1px solid; border-right:1px solid; text-align:center; height:20px;"
                >
                  <table width="100%" cellspacing="0" cellpadding="0">
                    <tr>
                      <td width="30%" style="border-right:1px solid; height:20px;"></td>
                      <td width="70%"></td>
                    </tr>
                  </table>
                </td>

                <td width="10%" style="border-top:1px solid;  text-align:center; height:10px;">
                  <table width="100%" cellspacing="0" cellpadding="0">
                    <tr>
                      <td width="30%" style="border-right:1px solid; height:10px;">-</td>
                      <td width="70%">-</td>
                    </tr>
                  </table>
                </td>

                <td
                  width="8%"
                  style="border-top:1px solid; border-left:1px solid;  text-align:center; height:10px;"
                ></td>
              </tr>
            </table>
          </td>
        </tr>

        <tr>
          <td width="100%">
            <table cellspacing="0" cellpadding="0" width="100%">
              <tr>
                <td style="border-top:1px solid;  height:20px; text-align:center;" width="81%"></td>

                <td width="10%" style="border-top:1px solid;  text-align:center; height:20px;">
                  <table width="100%" cellspacing="0" cellpadding="0">
                    <tr>
                      <td width="30%" style="border-right:0px solid; height:20px;"></td>
                      <td width="70%">Taxable Value</td>
                    </tr>
                  </table>
                </td>
                <td
                  width="8%"
                  style="border-top:1px solid; border-left:1px solid;  text-align:center; height:20px;"
                >{{invoiceData.taxableAmount}}</td>
              </tr>
            </table>
          </td>
        </tr>

        <tr>
          <td width="100%">
            <table cellspacing="0" cellpadding="0" width="100%">
              <tr>
                <td style="border-top:1px solid;  height:20px; text-align:center;" width="81%"></td>

                <td width="10%" style="border-top:1px solid;  text-align:center; height:20px;">
                  <table width="100%" cellspacing="0" cellpadding="0">
                    <tr>
                      <td width="30%" style="border-right:0px solid; height:20px;"></td>
                      <td width="70%">Add CGST</td>
                    </tr>
                  </table>
                </td>
                <td
                  width="8%"
                  style="border-top:1px solid; border-left:1px solid;  text-align:center; height:20px;"
                >{{invoiceData.cgst}}</td>
              </tr>
            </table>
          </td>
        </tr>

        <tr>
          <td width="100%">
            <table cellspacing="0" cellpadding="0" width="100%">
              <tr>
                <td style="border-top:1px solid;  height:20px; text-align:center;" width="81%"></td>

                <td width="10%" style="border-top:1px solid;  text-align:center; height:20px;">
                  <table width="100%" cellspacing="0" cellpadding="0">
                    <tr>
                      <td width="30%" style="border-right:0px solid; height:20px;"></td>
                      <td width="70%">Add SGST</td>
                    </tr>
                  </table>
                </td>
                <td
                  width="8%"
                  style="border-top:1px solid; border-left:1px solid;  text-align:center; height:20px;"
                >{{invoiceData.sgst}}</td>
              </tr>
            </table>
          </td>
        </tr>

        <tr>
          <td width="100%">
            <table cellspacing="0" cellpadding="0" width="100%">
              <tr>
                <td style="border-top:1px solid;  height:20px; text-align:center;" width="81%"></td>

                <td width="10%" style="border-top:1px solid;  text-align:center; height:20px;">
                  <table width="100%" cellspacing="0" cellpadding="0">
                    <tr>
                      <td width="30%" style="border-right:0px solid; height:20px;"></td>
                      <td width="70%">Add IGST</td>
                    </tr>
                  </table>
                </td>
                <td
                  width="8%"
                  style="border-top:1px solid; border-left:1px solid;  text-align:center; height:20px;"
                >{{invoiceData.igst}}</td>
              </tr>
            </table>
          </td>
        </tr>

        <tr>
          <td width="100%">
            <table cellspacing="0" cellpadding="0" width="100%">
              <tr>
                <td style="border-top:1px solid;  height:20px; text-align:center;" width="81%"></td>

                <td width="10%" style="border-top:1px solid;  text-align:center; height:20px;">
                  <table width="100%" cellspacing="0" cellpadding="0">
                    <tr>
                      <td width="30%" style="border-right:0px solid; height:20px;"></td>
                      <td width="70%">Net Invoice Value</td>
                    </tr>
                  </table>
                </td>
                <td
                  width="8%"
                  style="border-top:1px solid; border-left:1px solid;  text-align:center; height:20px;"
                >{{invoiceData.totalAmountAfterTax}}</td>
              </tr>
            </table>
          </td>
        </tr>

        <tr>
          <td width="100%">
            <table cellspacing="0" cellpadding="0" width="100%">
              <tr>
                <td width="100%" style="border-top:1px solid;  text-align:center; height:20px;">
                  <table width="100%" cellspacing="0" cellpadding="0">
                    <tr>
                      <td
                        width="50%"
                        style="border-right:1px solid; height:20px;"
                      >Net Invoice Value in Words</td>
                      <td width="50%">{{totalPrice}} only</td>
                    </tr>
                  </table>
                </td>
              </tr>
            </table>
          </td>
        </tr>

        <tr>
          <td width="100%">
            <table cellspacing="0" cellpadding="0" width="100%">
              <tr>
                <td
                  style="border-top:1px solid; border-right:1px solid;  height:20px; padding-left:10px;"
                  width="50%"
                >
                  <p
                    style="text-align:left:"
                  >CERTIFIED THAT THE PARTICULARS GIVEN ABOVE ARE TRUE AND CORRECT</p>
                  <p style="text-align:left:">1. Goods received in good order and condition.</p>
                  <p style="text-align:left:">2. Subject to Kolkata Juridiction only.</p>
                  <p style="text-align:left:">3. Thank you for your Business</p>
                </td>

                <td width="50%" style="border-top:1px solid;  text-align:center; height:5px;">
                  <p
                    style="font-size:20px; font-weight:bold; margin-top:0px; margin-bottom:0px;"
                  >Framing Indiaa</p>
                  <p
                    style="font-size:18px; font-weight:bold; margin-top:40px; margin-bottom:0px;"
                  >Authorized Signatory</p>
                </td>
              </tr>
            </table>
            <tr>
              <td style="border-top:1px solid;"></td>
            </tr>
          </td>
        </tr> -->
      </table>
    </div>
  </div>
</template>

<script>
import config from "./../../config.json";
var writtenNumber = require("written-number");
writtenNumber.defaults.lang = "en";
export default {
  data() {
    return {
      title: "buyer copy",
      enquiryData: null,
      totalPrice: null,
      output: null
    };
  },

  created() {
    this.axios
      .get(config.API + "Enquiries/" + this.$route.params.id, {
        headers: { Authorization: "Bearer " + sessionStorage.token }
      })
      .then(res => {
        this.enquiryData = res.data;
      })
      .catch(err => {
        console.log(err.message);
      });
  },

  methods: {
    back() {
      this.$router.go(-1);
    },
    print() {
      this.$htmlToPaper("printMe");
    }
  }
};
</script>

<style>
#printMe {
  width: 280mm;
  height: auto;
  margin: 0 auto;
  padding: 20px;
}
td {
  font-size: 11px !important;
}

@media all {
  .page-break {
    display: none;
  }
}

@media print {
  .page-break {
    display: block;
    page-break-before: always;
  }
}

body {
  font-family: "Droid Sans", sans-serif !important;
}
</style>
